import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "ticketino-api-client";
import { useLanguage } from "../../hooks/useLanguage";

import Header from "../components/Header";
import Footer from "../components/Footer";

const AccountConfirmationCode = () => {
    const [regularToken, setRegularToken] = useState(null);
    const [username, setUsername] = useState('');
    const [loginUserId, setLoginUserId] = useState('');
    const [confirmationCode, setConfirmationCode] = useState('');
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const [resources, setResources] = useState({});
    const { language } = useLanguage();

    const navigate = useNavigate();
    let baseUrl = process.env.REACT_APP_BASEURL_API;
    api.defaults.baseURL = baseUrl;

    useEffect(() => {
        setUsername(localStorage.getItem("accountRegistrationEmail"));
        setLoginUserId(localStorage.getItem("accountLoginUserId"));
        
        // Clear any old authentication tokens
        localStorage.removeItem("buyerToken");
        localStorage.removeItem("username");
        localStorage.removeItem("loggedInOrganizerId");
        
        loadToken();
    }, []);

    useEffect(() => {
        requestResources();
    }, [language]);

    const loadToken = async () => {
        await axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
            api.defaults.headers.common['Authorization'] = "Bearer " + res.data;

            localStorage.setItem("token", res.data);
            setRegularToken(res.data);

            requestFormSettings();
        });
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            //setPosId(res.data.posId);
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    // Simple Confirmation Code validation regex - checking if it's not empty
    const isValidConfirmationCode = (code) => {
        return code && code.trim().length > 0;
    };

    const handleCheckConfirmationCode = async (e) => {
        e.preventDefault();

        if (!isValidConfirmationCode(confirmationCode)) {
            setError(resources?.ConfirmationCodeError || "Please enter a valid confirmation code.");
            return;
        }

        setError(""); // Clear error if valid

        try {
            const isConfirmationCodeValid = await ConfirmRegistrationWithCode(loginUserId, confirmationCode);

            if (isConfirmationCodeValid) {
                navigate(`/${language}/account-registration`);
            } else {
                setError(resources?.ConfirmationCodeError || "The confirmation code is invalid or expired.");
            }
        } catch (err) {
            console.error('confirmation code check failed:', err.response?.data || err.message);
            setError(resources?.ConfirmationCodeError || "The confirmation code is invalid or expired.");
        }
    };

    const ConfirmRegistrationWithCode = async (loginUserId, confirmationCode) => {
        try {
            const response = await axios
                //.post(`https://localhost:44317/Account/CompleteRegistrationExternal?loginUserId=${loginUserId}&validationCode=${confirmationCode}`);
                .post(`https://accounts.ticketino.com/Account/CompleteRegistrationExternal?loginUserId=${loginUserId}&validationCode=${confirmationCode}`);
            
            return response.status === 200; // OK response
        } catch (error) {
            console.error(error.response?.data || error.message);
            return false; // NotFound or other error
        }
    };

    const handleRequestNewCode = async () => {
        setError('');
        setSuccessMessage('');
        
        try {
            await requestConfirmationCode(username);
            setSuccessMessage(resources?.ConfirmationCodeRequestSuccess || "A new confirmation code has been sent to your email address.");
        } catch (err) {
            console.error('Request new code failed:', err.response?.data || err.message);
            setError("Failed to request new code. Please try again.");
        }
    };

    const requestConfirmationCode = async (username) => {
        await axios
            //.post(`https://localhost:44317/Account/RegisterExternal?username=${username}`)
            .post(`https://accounts.ticketino.com/Account/RegisterExternal?username=${username}`)
            .catch((error) => console.error(error.response.data));
    };

    return (
        <>
            <Header language={language} pagePath="account-login" pageTitle={resources?.ConfirmationCodeTitle}
                ticketCount={0} />

            <div className="page-container">

                <div className="container wrapper">

                    <div className="row">
                        <div className="col-md-12 text-center">
                            <span>{resources?.ConfirmationCodeDesc}</span>
                        </div>
                    </div>

                    {/* email that code was sent to */}
                    <div className="form-group row mb-5">
                        <div className="col-md-12 text-center">
                            <span>{resources?.ConfirmationCodeDesc2} – {username}</span>
                        </div>
                    </div>

                    {/* inputs */}
                    <form onSubmit={handleCheckConfirmationCode}>
                        <div className="form-group row">
                            <label htmlFor="staticEmail" className="col-sm-4 col-form-label">{resources?.ConfirmationCodeConfirm}</label>
                            <div className="col-sm-8">
                                <input
                                    className="form-control"
                                    name="confirmationCode"
                                    value={confirmationCode}
                                    onChange={(e) => {
                                        setConfirmationCode(e.target.value);
                                        if (error && isValidConfirmationCode(e.target.value)) setError('');
                                        if (successMessage) setSuccessMessage('');
                                    }}
                                />
                                {error && (
                                    <div className="text-danger mt-2 fw-bold">{error}</div>
                                )}
                                {successMessage && (
                                    <div className="mt-2 fw-bold">{successMessage}</div>
                                )}
                            </div>
                        </div>

                        {/* button */}
                        <div className="row mt-5">
                            <div className="col-md-12 text-center">
                                <button className="btn-custom btn-navigation" type="submit" style={{minWidth: "400px"}}>
                                    {resources?.ConfirmationCodeContinue}
                                </button>
                            </div>
                        </div>

                        {/* request new code button */}
                        {error && (
                            <div className="row mt-3">
                                <div className="col-md-12 text-center">
                                    <button 
                                        className="btn-custom btn-secondary" 
                                        type="button" 
                                        onClick={handleRequestNewCode}
                                        style={{minWidth: "400px"}}
                                    >
                                        {resources?.ConfirmationCodeRequestNew}
                                    </button>
                                </div>
                            </div>
                        )}

                    </form>
                </div>

            </div>

            <Footer language={language} />
        </>
    )
}

export default AccountConfirmationCode;
